// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"aeb26560","496":"420391b3","498":"a89de0d4","703":"1964499f"}[chunkId] + ".chunk.js";
};